<template>
  <content-layout :title="title" :head-image="headImage" :tabs="tabs" v-model="activeTab">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div class="activity-item mgui-container" slot="/groups">
      <i-table :columns="groupCol" :data="groupData"></i-table>
    </div>
    <div class="activity-item mgui-container" slot="/groups/post">
      <Form ref="formGroup" :model="formItem" label-position="top" :rules="ruleData">
        <FormItem label="管理组名" prop="title">
          <Input v-model="formItem.title" placeholder="请输入管理组名"></Input>
        </FormItem>
        <FormItem label="英文标识" prop="name">
          <Input v-model="formItem.name" placeholder="请输入英文名"></Input>
        </FormItem>
        <FormItem label="权限节点" class="ivu-tree-inner" prop="node">
          <Input v-model="formItem.node" placeholder="请选择管理项目" :disabled="true"></Input>
          <Tree :data="handleMenusData()" @on-check-change="treeChange" show-checkbox></Tree>
        </FormItem>
        <FormItem label="" style="padding-top:30px">
          <Button type="primary" @click="submitGroup('formGroup')">确定{{formItem.id==0?'新增':'编辑'}}</Button>
          <Button type="default" @click="clearForm">取消</Button>
        </FormItem>
      </Form>
      <Spin v-if="spinShow" fix>
        <Icon type="load-c" size="18" class="spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>

  </content-layout>
</template>


<script>
  import {fetch, post} from '../fetch/api'
  const formData = {
    'id': 0,
    'title': null,
    'name': null,
    'node': ''
  }
  export default {
    name: 'ActivityMenus',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      return {
        title: '权限管理',
        tabs: [],
        activeTab: null,
        spinShow: true,
        groupCol: [
          {type: 'selection', width: 60, align: 'center', key: 'id'},
          {title: '组名', key: 'title'},
          {title: '节点', key: 'node'},
          {
            title: '操作',
            key: 'action',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let editDisabled = params.row.id === 1 || !this.$menu.isPower('group', 'edit')
              let delDisabled = params.row.id === 1 || !this.$menu.isPower('group', 'del')
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    disabled: editDisabled,
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editGroup(params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    disabled: delDisabled,
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.remove(params.id)
                    }
                  }
                }, '删除')
              ])
            }
          }
        ],
        groupData: [],
        menusData: [],
        formItem: formData,
        headImage: '/static/images/bg/money.jpeg',
        ruleData: {
          title: [
            {required: true, message: '请输入权限组名称', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入英文标识', trigger: 'blur'}
          ],
          node: [
            {required: true, message: '请选择管理项目', trigger: 'change'}
          ]
        }
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      }
    },
    mounted () {
      this.fetchData()
      this.activeTab = '/groups'
      this.$router.push({'path': '/groups'})
      setTimeout(() => {
        this.setTabs()
      }, 400)
    },
    methods: {
      setTabs () {
        this.tabs = [
          {'title': '权限列表', 'key': '/groups', 'visible': true},
          {'title': '添加权限', 'key': '/groups/post', 'visible': true, 'disabled': !this.$menu.isPower('group', 'edit')}
        ]
      },
      routeChange (route) {
        let action = route.params.action
        if (action === undefined) {
          this.activeTab = '/groups'
          this.fetchData()
        }
        if (action === 'post') {
          this.activeTab = '/groups/post'
          this.fetcMenus()
          this.spinShow = false
        }
      },
      fetchData () {
        fetch('console/groups/0').then(res => {
          let data = res
          // 超级管理员禁止编辑
          for (let k in data) {
            data[k]._disabled = data[k].id === 1
          }
          this.groupData = data
          this.spinShow = false
        })
      },
      fetcMenus () {
        fetch('console/menus/0').then(res => {
          this.menusData = res
        })
      },
      handleMenusData () {
        if (this.formItem.node === '') return this.menusData
        let tmpData = JSON.parse(JSON.stringify(this.menusData))
        for (let i in tmpData) {
          let t = tmpData[i]
          let c = t.children
          if (this.inArr(tmpData[i].id)) tmpData[i].checked = true
          if (c.length > 0) {
            for (let k in c) {
              if (this.inArr(c[k].id)) c[k].checked = true
            }
          }
        }
        return tmpData
      },
      inArr (val) {
        let nodes = this.formItem.node.split(',')
        for (let i in nodes) {
          if (Number(nodes[i]) === Number(val)) return true
        }
        return false
      },
      treeChange (data) {
        let ids = []
        for (let k in data) {
          ids.push(data[k].id)
        }
        this.formItem.node = ids.join(',')
      },
      remove (index) {
        this.groupData.splice(index, 1)
      },
      editGroup (row) {
        this.formItem = {
          'id': row.id,
          'title': row.title,
          'name': row.name,
          'node': row.node
        }
        this.$router.push('/groups/post')
      },
      submitGroup (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = this.formItem
            post(`/console/group`, data)
            .then(res => {
              if (res.status === 'ok') {
                this.$Message.success(data.id === 0 ? '添加成功' : '编辑成功')
                this.formItem = JSON.parse(JSON.stringify(formData))
                if (data.id > 0) {
                  // this.activeTab = '/groups'
                  this.$router.push('/groups')
                }
                this.fetchData()
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
      },
      clearForm () {
        this.activeTab = '/groups'
        this.formItem = JSON.parse(JSON.stringify(formData))
      }
    }
  }
</script>

<style scoped>

</style>
